/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransferringVets } from '../../models/transferring-vets';

export interface FindTransferringVets$Params {

/**
 * Space-separated words, which all will be looked for in the name, keywords, and city fields
 */
  searchStr?: string;

/**
 * Max. number of results. Allowed range 0 < count <= 100
 */
  count?: number;
}

export function findTransferringVets(http: HttpClient, rootUrl: string, params?: FindTransferringVets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransferringVets>>> {
  const rb = new RequestBuilder(rootUrl, findTransferringVets.PATH, 'get');
  if (params) {
    rb.query('searchStr', params.searchStr, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TransferringVets>>;
    })
  );
}

findTransferringVets.PATH = '/api/values/transferring-vets';
